import { useState, useEffect, useCallback, useMemo } from 'react';
import {
  flattenDealCheckerTasks,
  groupResultsByTask,
} from '../../Tools/dealCheckerHistoryUtils';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Fetches deal-tag check history grouped into batches. Shared by the Manage
// page's merged grid and the deal-tag filter view.
const useDealTagHistory = (token) => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchHistory = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${API_BASE_URL}/utility_dealtag/deal-checker-history?page=1&limit=100`, {
        method: 'GET',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      });
      if (!response.ok) throw new Error('Failed to load deal tag history');
      const data = await response.json();
      if (data.success && Array.isArray(data.tasks)) {
        setResults(flattenDealCheckerTasks(data.tasks));
      } else {
        setResults([]);
      }
    } catch (err) {
      setError(err.message || 'Failed to load deal tag history');
      setResults([]);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => { fetchHistory(); }, [fetchHistory]);

  const batches = useMemo(() => groupResultsByTask(results, 'newest'), [results]);

  return { loading, error, batches };
};

export default useDealTagHistory;
